import { DECADES, type Category } from '@banger/shared';

export type InputKind = 'text' | 'decade' | 'yesno' | 'year';

/** Matches the server's answer length limit. */
export const MAX_TEXT = 100;
export const YEAR_MIN = 1960;
export const YEAR_START = 1990;
export function yearMax(): number {
  return new Date().getFullYear();
}

export function inputKind(cat: Category): InputKind {
  switch (cat) {
    case 'title':
    case 'artist':
      return 'text';
    case 'decade':
      return 'decade';
    case 'before2000':
      return 'yesno';
    case 'year4':
      return 'year';
  }
}

/** The value to send for a raw input string; null = not submittable. */
export function toAnswerValue(cat: Category, raw: string): string | number | boolean | null {
  switch (inputKind(cat)) {
    case 'text': {
      const t = raw.trim().slice(0, MAX_TEXT).trim();
      return t === '' ? null : t;
    }
    case 'decade': {
      const n = /^\d{4}$/.test(raw) ? Number(raw) : NaN;
      return (DECADES as readonly number[]).includes(n) ? n : null;
    }
    case 'yesno':
      return raw === 'yes' ? true : raw === 'no' ? false : null;
    case 'year': {
      const n = /^\d{4}$/.test(raw.trim()) ? Number(raw.trim()) : NaN;
      return n >= YEAR_MIN && n <= yearMax() ? n : null;
    }
  }
}

/** 1980 → "80s". */
export function decadeLabel(decade: number): string {
  return `${String(decade).slice(2)}s`;
}

const COLOR_NAMES: Record<Category, string> = {
  title: 'pink',
  artist: 'cyan',
  decade: 'gold',
  before2000: 'green',
  year4: 'violet',
};

/** The category's color as a word, for "Tap a pink square". */
export function colorName(cat: Category): string {
  return COLOR_NAMES[cat];
}
